// Google AdSense setup — see /ads-guide for step-by-step instructions.
export const ADSENSE_CLIENT = process.env.REACT_APP_ADSENSE_CLIENT || "";

// One AdSense ad unit ID ("data-ad-slot") per size. Leave empty to show placeholders.
export const AD_UNITS = {
  leaderboard: "", // 728x90
  billboard: "", // 970x250
  rectangle: "", // 300x250
  half_page: "", // 300x600
  large_mobile: "", // 320x100
  responsive: "", // responsive display
  infeed: "", // between match lists
};

// Optional: give a specific placement its own ad unit, e.g. { "home-side-1": "1234567890" }
export const PLACEMENT_OVERRIDES = {};

export const slotFor = (size, placement) =>
  PLACEMENT_OVERRIDES[placement] || AD_UNITS[size] || "";

export const loadAdSense = () => {
  if (!ADSENSE_CLIENT || document.getElementById("adsense-script")) return;
  const s = document.createElement("script");
  s.id = "adsense-script";
  s.async = true;
  s.crossOrigin = "anonymous";
  s.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${ADSENSE_CLIENT}`;
  document.head.appendChild(s);
};
